export function sameIds(a: readonly string[], b: readonly string[]): boolean {
  return a.length === b.length && a.every((id, index) => id === b[index]);
}

/**
 * Schneidet eine gespeicherte Auswahl auf die Projekte zu, die der Nutzer noch sieht. Bleibt
 * nichts uebrig oder alles, gilt wieder „Alle“ (leere Liste).
 */
export function selectionWithin(selected: readonly string[], available: readonly string[]): string[] {
  const kept = selected.filter((id) => available.includes(id));
  return kept.length === available.length ? [] : kept;
}
